module.exports = __webpack_public_path__ + "media/musicbg.9f05decd.mp3";